import { put, takeLatest } from 'redux-saga/effects';
import { getUserFlags } from '../userFlags/actionCreators';
import { getUserStatus, selectHeroAccount } from '../userLogin/actionCreators';
import { logoutDone } from './actionCreators';
import { REFRESH_TOKEN_DONE, LOGIN_DONE, LOGOUT } from './actionTypes';
function* getUserData(action) {
    const { preselectedAccount } = action.data;
    if (preselectedAccount) {
        yield put(selectHeroAccount({ selected_account_id: preselectedAccount }));
    }
    yield put(getUserFlags());
    yield put(getUserStatus());
}
export function* watchRefreshTokenCalls() {
    yield takeLatest(REFRESH_TOKEN_DONE, getUserData);
}
export function* watchLoginDoneCalls() {
    yield takeLatest(LOGIN_DONE, getUserData);
}
function* logout() {
    yield put(logoutDone());
    localStorage.removeItem('auth');
    localStorage.removeItem('authStatus');
}
export function* watchLogoutCalls() {
    yield takeLatest(LOGOUT, logout);
}
//# sourceMappingURL=saga.js.map